angular.module('impactx.opengovernmentdata').service('OpenGovernmentDataService', [
    '$mdDialog',
    'dataGen',
    OpenGovernmentDataService
]);

function OpenGovernmentDataService($mdDialog, dataGen) {
    var self = this;

    self.openEditDialog = function (event, ogdId, bksId, prsId, pohId, reportSPO) {
        return $mdDialog.show({
            controller: 'OpenGovernmentDataEditDialogCtrl',
            controllerAs: 'ctrl',
            locals: {
                ogdId: ogdId,
                bksId: bksId,
                prsId: prsId,
                pohId: pohId,
                reportSPO: reportSPO
            },
            templateUrl: 'modules/opengovernmentdata/templates/opengovernmentdataedit.dialog.html',
            parent: angular.element(document.body),
            bindToController: true,
            targetEvent: event,
            clickOutsideToClose: false
        });
    };

    self.openAgreementDialog = function (event, bksIds, prsIds, pohIds, isWarning) {
        return $mdDialog.show({
            controller: 'OpenGovernmentDataAgreementDialogCtrl',
            controllerAs: 'ctrl',
            locals: {
                bksIds: bksIds ? bksIds : [],
                prsIds: prsIds ? prsIds : [],
                pohIds: pohIds ? pohIds : [],
                isWarning: isWarning
            },
            templateUrl: 'modules/opengovernmentdata/templates/opengovernmentdataagreement.dialog.html',
            parent: angular.element(document.body),
            bindToController: true,
            targetEvent: event,
            clickOutsideToClose: false
        });
    };

    self.openReadOnlyDialog = function (event, ogdId, buyerOrderReference) {
        return $mdDialog.show({
            controller: 'OpenGovernmentDataReadonlyDialogCtrl',
            controllerAs: 'ctrl',
            locals: {
                ogdId: ogdId,
                buyerOrderReference: buyerOrderReference
            },
            templateUrl: 'modules/opengovernmentdata/templates/opengovernmentdatareadonly.dialog.html',
            parent: angular.element(document.body),
            bindToController: true,
            targetEvent: event,
            clickOutsideToClose: true
        });
    };
    self.openEditDialogWithWarnings = function (pohId)
    {
         self.openEditDialog(event, 0, 0, 0, pohId, false).then(function () {
            self.openAgreementDialog(event, [], [], [Number(pohId)], false)
                .then(function () {
                    ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                }, function () {
                    self.rejectReport([Number(pohId)]);
                });
        });
    };

    self.rejectReport = function (pohIds) {
        return dataGen.postAsForm({}, {pohIds: pohIds}, "/opengovernmentdata/report/reject");
    };

    return {
        openEditDialog: self.openEditDialog,
        openAgreementDialog: self.openAgreementDialog,
        openReadOnlyDialog: self.openReadOnlyDialog,
        rejectReport: self.rejectReport,
        openEditDialogWithWarnings: self.openEditDialogWithWarnings
    };


}